import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as nls from '../../../nls.js';
import * as dom from '../../../base/browser/dom.js';
import { Action } from '../../../base/common/actions.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { Range } from '../../common/core/range.js';
import { Codicon } from '../../../base/common/codicons.js';
export var InlineDiffMargin = /*#__PURE__*/function (_Disposable) {
  _inherits(InlineDiffMargin, _Disposable);

  var _super = _createSuper(InlineDiffMargin);

  function InlineDiffMargin(_viewZoneId, _marginDomNode, editor, diff, _contextMenuService, _clipboardService) {
    var _this;

    _classCallCheck(this, InlineDiffMargin);

    _this = _super.call(this);
    _this._viewZoneId = _viewZoneId;
    _this._marginDomNode = _marginDomNode;
    _this.editor = editor;
    _this.diff = diff;
    _this._contextMenuService = _contextMenuService;
    _this._clipboardService = _clipboardService;
    _this._visibility = false; // make sure the diff margin shows above overlay.

    _this._marginDomNode.style.zIndex = '10';
    _this._diffActions = document.createElement('div');
    _this._diffActions.className = Codicon.lightBulb.classNames + ' lightbulb-glyph';
    _this._diffActions.style.position = 'absolute';
    var lineHeight = editor.getOption(51
    /* lineHeight */
    );
    var lineFeed = editor.getModel().getEOL();
    _this._diffActions.style.right = '0px';
    _this._diffActions.style.visibility = 'hidden';
    _this._diffActions.style.height = "".concat(lineHeight, "px");
    _this._diffActions.style.lineHeight = "".concat(lineHeight, "px");

    _this._marginDomNode.appendChild(_this._diffActions);

    var actions = []; // default action

    actions.push(new Action('diff.clipboard.copyDeletedContent', diff.originalEndLineNumber > diff.modifiedStartLineNumber ? nls.localize('diff.clipboard.copyDeletedLinesContent.label', "Copy deleted lines") : nls.localize('diff.clipboard.copyDeletedLinesContent.single.label', "Copy deleted line"), undefined, true, function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._clipboardService.writeText(diff.originalContent.join(lineFeed) + lineFeed);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }));
    var currentLineNumberOffset = 0;
    var copyLineAction = undefined;

    if (diff.originalEndLineNumber > diff.modifiedStartLineNumber) {
      copyLineAction = new Action('diff.clipboard.copyDeletedLineContent', nls.localize('diff.clipboard.copyDeletedLineContent.label', "Copy deleted line ({0})", diff.originalStartLineNumber), undefined, true, function () {
        return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this._clipboardService.writeText(diff.originalContent[currentLineNumberOffset]);

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
      });
      actions.push(copyLineAction);
    }

    var readOnly = editor.getOption(72
    /* readOnly */
    );

    if (!readOnly) {
      actions.push(new Action('diff.inline.revertChange', nls.localize('diff.inline.revertChange.label', "Revert this change"), undefined, true, function () {
        return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var column, _column;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (diff.modifiedEndLineNumber === 0) {
                    // deletion only
                    column = editor.getModel().getLineMaxColumn(diff.modifiedStartLineNumber);
                    editor.executeEdits('diffEditor', [{
                      range: new Range(diff.modifiedStartLineNumber, column, diff.modifiedStartLineNumber, column),
                      text: lineFeed + diff.originalContent.join(lineFeed)
                    }]);
                  } else {
                    _column = editor.getModel().getLineMaxColumn(diff.modifiedEndLineNumber);
                    editor.executeEdits('diffEditor', [{
                      range: new Range(diff.modifiedStartLineNumber, 1, diff.modifiedEndLineNumber, _column),
                      text: diff.originalContent.join(lineFeed)
                    }]);
                  }

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
      }));
    }

    var showContextMenu = function showContextMenu(x, y) {
      _this._contextMenuService.showContextMenu({
        getAnchor: function getAnchor() {
          return {
            x: x,
            y: y
          };
        },
        getActions: function getActions() {
          if (copyLineAction) {
            copyLineAction.label = nls.localize('diff.clipboard.copyDeletedLineContent.label', "Copy deleted line ({0})", diff.originalStartLineNumber + currentLineNumberOffset);
          }

          return actions;
        },
        autoSelectFirstItem: true
      });
    };

    _this._register(dom.addStandardDisposableListener(_this._diffActions, 'mousedown', function (e) {
      var _dom$getDomNodePagePo = dom.getDomNodePagePosition(_this._diffActions),
          top = _dom$getDomNodePagePo.top,
          height = _dom$getDomNodePagePo.height;

      var pad = Math.floor(lineHeight / 3);
      e.preventDefault();
      showContextMenu(e.posx, top + height + pad);
    }));

    _this._register(editor.onMouseMove(function (e) {
      if (e.target.type === 8
      /* CONTENT_VIEW_ZONE */
      || e.target.type === 5
      /* GUTTER_VIEW_ZONE */
      ) {
        var viewZoneId = e.target.detail.viewZoneId;

        if (viewZoneId === _this._viewZoneId) {
          _this.visibility = true;
          currentLineNumberOffset = _this._updateLightBulbPosition(_this._marginDomNode, e.event.browserEvent.y, lineHeight);
        } else {
          _this.visibility = false;
        }
      } else {
        _this.visibility = false;
      }
    }));

    _this._register(editor.onMouseDown(function (e) {
      if (!e.event.rightButton) {
        return;
      }

      if (e.target.type === 8
      /* CONTENT_VIEW_ZONE */
      || e.target.type === 5
      /* GUTTER_VIEW_ZONE */
      ) {
        var viewZoneId = e.target.detail.viewZoneId;

        if (viewZoneId === _this._viewZoneId) {
          e.event.preventDefault();
          currentLineNumberOffset = _this._updateLightBulbPosition(_this._marginDomNode, e.event.browserEvent.y, lineHeight);
          showContextMenu(e.event.posx, e.event.posy + lineHeight);
        }
      }
    }));

    return _this;
  }

  _createClass(InlineDiffMargin, [{
    key: "visibility",
    get: function get() {
      return this._visibility;
    },
    set: function set(_visibility) {
      if (this._visibility !== _visibility) {
        this._visibility = _visibility;

        if (_visibility) {
          this._diffActions.style.visibility = 'visible';
        } else {
          this._diffActions.style.visibility = 'hidden';
        }
      }
    }
  }, {
    key: "_updateLightBulbPosition",
    value: function _updateLightBulbPosition(marginDomNode, y, lineHeight) {
      var _dom$getDomNodePagePo2 = dom.getDomNodePagePosition(marginDomNode),
          top = _dom$getDomNodePagePo2.top;

      var offset = y - top;
      var lineNumberOffset = Math.floor(offset / lineHeight);
      var newTop = lineNumberOffset * lineHeight;
      this._diffActions.style.top = "".concat(newTop, "px");
      return lineNumberOffset;
    }
  }]);

  return InlineDiffMargin;
}(Disposable);